import { useNavigate } from "react-router-dom"
import Router from "@/router/router"
import { useEffect } from "react"
import { useSetUpAxios } from "./app/api"

import { Settings } from "luxon"
import { changeInvoiceQRCode, changePos } from "./app/appSlice"
//@ts-expect-error
type Gtag = import("@types/gtag.js")

Settings.defaultZone = "Asia/Hong_Kong"

declare global {
  interface Window {
    gtag: Gtag.Gtag
  }
}

export default function App() {
  const location = useLocation()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  useSetUpAxios()

  const [searchParams, setSearchParams] = useSearchParams()
  const [init, setInit] = useState(false)

  useEffect(() => {
    if (
      location.pathname === "/tnc" ||
      location.pathname === "/privatePolicy"
    ) {
      navigate(location.pathname)
      setInit(true)
      return
    }

    navigate("/")
    dispatch(changeInvoiceQRCode(searchParams.get("code") || ""))
    dispatch(changePos(searchParams.get("pos") || ""))
    setInit(true)
  }, [])

  if (import.meta.env.VITE_APP_MODE === "PROD") {
    //@ts-expect-error
    window.dataLayer = window.dataLayer || []
    function gtag() {
      //@ts-expect-error
      dataLayer.push(arguments)
    }
    window.gtag = gtag
    window.gtag("js", new Date())
    window.gtag("config", "G-LL1LN85NWC")
  } else {
    //@ts-expect-error
    window.gtag = (type: string, name: string, val: object) => {
      console.log(`GA ${type}: ${name}`, val)
    }
  }

  return (
    <div>
      {init && (
        <>
          <Router />
        </>
      )}
    </div>
  )
}
